module.exports = __webpack_public_path__ + "img/hr-steel-furnace.693c18e1.png";